import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const PROJECT_TIMESHEET_ACCESS_QUERY = gql`
  query GetProjectTimesheetAccess(
    $projectId: String
    $includeLocationFullPath: Boolean!
    $includeServiceCenterFullPath: Boolean!
    $includeDivisionFullPath: Boolean!
    $includeCostCenterFullPath: Boolean!
    $includeDepartmentFullPath: Boolean!
    $includeEmployeeTypeFullPath: Boolean!
    $taskAssignmentsFilter: TaskAssignmentsFilter
    $policy: String
  ) {
    project(projectId: $projectId) {
      id
      billingType {
        id
        displayText
        uri
      }
      timesheetAccess(policy: $policy) {
        allUsers {
          id
          isAssigned
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
        }
        locations {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeLocationFullPath)
        }
        costCenters {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeCostCenterFullPath)
        }
        divisions {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeDivisionFullPath)
        }
        departments {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeDepartmentFullPath)
        }
        serviceCenters {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeServiceCenterFullPath)
        }
        employeeTypes {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          fullPath @include(if: $includeEmployeeTypeFullPath)
        }
        resources {
          id
          displayText
          assignedTaskCount(taskAssignmentsFilter: $taskAssignmentsFilter)
          assignedBillingRates {
            billingRate {
              id
              displayText
            }
            rate {
              amount
              currency {
                id
                uri
                displayText
                name
                symbol
              }
            }
            asOfDate
          }
          slug
        }
      }
    }
  }
`;

export const useProjectTimesheetAccessQuery = options =>
  useQuery(PROJECT_TIMESHEET_ACCESS_QUERY, options);
